// @ts-nocheck
/*
	Catálogo de Horarios dentro de WAPP (Esteban, 2026-09-24: "igualito, idéntico a como se mira
	horarios.washingtonacademy.com").

	Es el mismo app.js del sitio (wa-horarios/public/assets/app.js), casi renglón por renglón, para
	que las dos pantallas no se separen: mismos filtros, misma hoja para la captura, mismo texto al
	copiar. Por eso va en JavaScript llano y sin revisión de tipos. Lo que cambia respecto al sitio:
	- vive dentro de un contenedor (root) y no de la página entera: busca sus piezas ahí adentro;
	- los datos llegan por WAPP (cargar / registrarCopia) en vez de fetch a /api/...;
	- abre en el plantel que se tiene elegido en WAPP, y sin tocar la dirección (#/p/…) del navegador;
	- las clases llevan el prefijo "wch" para no chocar con Bootstrap (.btn, .badge, .dropdown).
	Si se cambia una regla allá, hay que cambiarla aquí también.
*/

export interface OpcionesCatalogo {
	cargar: () => Promise<any>
	registrarCopia: (datos: any) => void
	plantelInicial: number | null
	logo: string
}

const MARCADO = (logo: string) => `
	<section data-wch="loading" class="wchCenterNote">Cargando horarios…</section>

	<section data-wch="campusStep" hidden>
		<h1 class="wchStepTitle">¿Qué plantel?</h1>
		<p class="wchStepLead">Elige uno para ver sus horarios. Después puedes agregar más.</p>
		<div data-wch="campusGrid" class="wchCampusGrid"></div>
	</section>

	<section data-wch="listStep" hidden>
		<div data-wch="filterBar" class="wchFilterBar">
			<button type="button" class="wchBtn wchBtnGhost" data-wch="backToCampus">◀ Plantel</button>
			<div data-wch="filters" class="wchFilters"></div>
			<input type="search" data-wch="search" class="wchSearch" placeholder="Buscar curso, horario, maestro…" autocomplete="off">
			<button type="button" class="wchBtn wchBtnPrimary wchBtnCopy" data-wch="copyList">Copiar</button>
			<button type="button" class="wchBtn wchBtnGhost" data-wch="restoreHidden" hidden></button>
			<button type="button" class="wchBtn wchBtnGhost" data-wch="clearFilters">Limpiar</button>
			<button type="button" class="wchBtn wchBtnGhost" data-wch="cleanView" title="Oculta los filtros para tomar la captura">Vista limpia</button>
		</div>

		<p data-wch="copyNote" class="wchCopyNote" hidden></p>

		<div class="wchSheet">
			<div class="wchSheetHead">
				<img class="wchSheetLogo" src="${logo}" alt="Washington Academy">
				<div class="wchSheetHeadText">
					<h2 data-wch="sheetTitle">Horarios</h2>
					<p data-wch="sheetSummary" class="wchSheetSummary"></p>
				</div>
			</div>
			<div data-wch="tableWrap" class="wchTableWrap"></div>
			<p class="wchSheetFoot">Washington Academy · Actualizado <span data-wch="stamp"></span></p>
		</div>
	</section>
`

/** Pinta el catálogo dentro de root. Devuelve la función que lo desmonta. */
export function montarCatalogo(root: HTMLElement, opciones: OpcionesCatalogo): () => void {
	"use strict";

	root.innerHTML = MARCADO(opciones.logo)
	var vivo = true

	var DIAS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
	// Cuántos horarios se copian de un jalón (Esteban, 2026-09-14): más que esto
	// es un mensaje ilegible para el cliente.
	var MAX_COPIAR = 15;
	var ESTADOS = { "por-comenzar": "Por comenzar", "en-curso": "En curso" };
	var MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio",
		"julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

	var data = null;
	// Lo que el botón copiaría: las filas que están en pantalla.
	var copiables = [];
	var state = {
		planteles: [],
		cursos: [],
		periodos: [],
		dias: [],
		estados: [],
		// Status de WAPP. Arranca en "Activo" a propósito: quien tiene permiso de ver
		// los demás debe elegirlo, nunca caer ahí sin darse cuenta (Esteban, 2026-09-14).
		status: [],
		q: "",
		// Horarios quitados a mano de esta vista. No se guardan: son para armar
		// un mensaje puntual sin pelearse con los filtros (Esteban, 2026-09-14).
		excluidos: []
	};

	function pieza(nombre) {
		return root.querySelector('[data-wch="' + nombre + '"]');
	}

	var el = {
		loading: pieza("loading"),
		campusStep: pieza("campusStep"),
		campusGrid: pieza("campusGrid"),
		listStep: pieza("listStep"),
		filters: pieza("filters"),
		filterBar: pieza("filterBar"),
		search: pieza("search"),
		tableWrap: pieza("tableWrap"),
		restoreHidden: pieza("restoreHidden"),
		copyList: pieza("copyList"),
		copyNote: pieza("copyNote"),
		sheetTitle: pieza("sheetTitle"),
		sheetSummary: pieza("sheetSummary"),
		stamp: pieza("stamp")
	};

	function sinAcentos(text) {
		return String(text || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
	}

	function unique(values) {
		var seen = Object.create(null);
		var out = [];
		values.forEach(function (value) {
			if (value !== "" && !seen[value]) {
				seen[value] = true;
				out.push(value);
			}
		});
		return out;
	}

	/** "Septiembre 2026" -> 2026*12+8, so periods sort by real time, newest first. */
	function periodoOrden(periodo) {
		var text = sinAcentos(periodo);
		var year = (text.match(/(19|20)\d{2}/) || [""])[0];
		var month = -1;
		for (var i = 0; i < MESES.length; i++) {
			if (text.indexOf(sinAcentos(MESES[i])) !== -1) {
				month = i;
				break;
			}
		}
		if (!year || month < 0) {
			return -1;
		}
		return parseInt(year, 10) * 12 + month;
	}

	// ---- filtering -------------------------------------------------------

	function porPlantel() {
		if (state.planteles.length < 1) {
			return [];
		}
		return data.horarios.filter(function (h) {
			return state.planteles.indexOf(h.plantel) !== -1;
		});
	}

	/**
	 * Junta las filas que comparten clave SIN reordenarlas por dentro: cada
	 * grupo sale en el lugar donde aparecio su PRIMERA fila.
	 *
	 * Asi se respeta la prioridad que ya trae el servidor (lo que esta por
	 * arrancar, arriba) y ademas los cursos y los periodos dejan de salir
	 * intercalados. Es estable: dos filas del mismo grupo conservan su orden.
	 */
	function agrupar(lista : any[], claves : string[]) {
		if (claves.length < 1) { return lista; }

		var orden : string[] = [];
		var cajas : any = {};

		lista.forEach(function (h : any) {
			var clave = claves.map(function (c : string) { return h[c]; }).join("\u0000");
			if (!cajas[clave]) { cajas[clave] = []; orden.push(clave); }
			cajas[clave].push(h);
		});

		return orden.reduce(function (acc : any[], clave : string) { return acc.concat(cajas[clave]); }, []);
	}

	/**
	 * Como se agrupa la lista segun lo que se este filtrando (Esteban, 2026-10-01):
	 *   - filtrando por curso        -> se agrupa por PERIODO
	 *   - filtrando por periodo solo -> se agrupa por CURSO
	 *   - sin ninguno de los dos     -> por PERIODO y dentro por CURSO
	 *
	 * El orden de los grupos NO se inventa aqui: sale de la prioridad del
	 * servidor, porque cada grupo se queda donde cayo su primera fila.
	 */
	function agrupado(lista : any[]) {
		if (state.cursos.length > 0) {
			return agrupar(lista, ["periodo"]);
		}
		if (state.periodos.length > 0) {
			return agrupar(lista, ["curso"]);
		}
		return agrupadoDoble(lista, "periodo", "curso");
	}

	/**
	 * Agrupa por una clave mayor y, DENTRO de cada bloque, por una menor.
	 *
	 * No se puede hacer con dos pasadas de agrupar(): la pasada de adentro
	 * mueve las filas y entonces el orden de los bloques de afuera ya no sale
	 * de su horario mas prioritario, sino del que quedo primero por accidente.
	 * Aqui los periodos conservan su prioridad y los cursos se juntan dentro.
	 */
	function agrupadoDoble(lista : any[], mayor : string, menor : string) {
		var salida : any[] = [];
		var bloque : any[] = [];
		var actual = null;

		agrupar(lista, [mayor]).forEach(function (h : any) {
			if (h[mayor] !== actual) {
				if (bloque.length > 0) { salida = salida.concat(agrupar(bloque, [menor])); }
				bloque = [];
				actual = h[mayor];
			}
			bloque.push(h);
		});

		if (bloque.length > 0) { salida = salida.concat(agrupar(bloque, [menor])); }

		return salida;
	}

	function filtrados() {
		var terms = sinAcentos(state.q).split(/\s+/).filter(function (t) { return t !== ""; });

		return agrupado(porPlantel().filter(function (h) {
			if (state.cursos.length > 0 && state.cursos.indexOf(h.curso) === -1) { return false; }
			if (state.periodos.length > 0 && state.periodos.indexOf(h.periodo) === -1) { return false; }
			if (state.estados.length > 0 && state.estados.indexOf(h.estado) === -1) { return false; }
			if (state.status.length > 0 && state.status.indexOf(h.status) === -1) { return false; }
			if (state.dias.length > 0) {
				var match = h.dias.some(function (d) { return state.dias.indexOf(d) !== -1; });
				if (!match) { return false; }
			}
			if (terms.length > 0) {
				var haystack = sinAcentos([h.curso, h.cursoFull, h.modulo, h.periodo, h.horario,
					h.maestro, h.inicioTexto].join(" "));
				return terms.every(function (t) { return haystack.indexOf(t) !== -1; });
			}
			return true;
		}));
	}

	// ---- multi-select dropdown ------------------------------------------

	/**
	 * options: [{value, label}]. Selection lives in state[key] and every change
	 * re-renders the list, so the dropdown never holds state of its own.
	 */
	function dropdown(label, key, options) {
		var wrap = document.createElement("div");
		wrap.className = "wchDrop";

		var selected = state[key];
		var button = document.createElement("button");
		button.type = "button";
		button.className = "wchDropBtn" + (selected.length > 0 ? " wchDropBtnOn" : "");
		button.textContent = selected.length > 0 ? label + " (" + selected.length + ")" : label;
		wrap.appendChild(button);

		var panel = document.createElement("div");
		panel.className = "wchDropPanel";
		panel.hidden = true;

		if (options.length > 8) {
			var finder = document.createElement("input");
			finder.type = "search";
			finder.className = "wchDropFind";
			finder.placeholder = "Buscar…";
			finder.addEventListener("input", function () {
				var needle = sinAcentos(finder.value);
				panel.querySelectorAll(".wchDropItem").forEach(function (item) {
					item.hidden = needle !== "" && sinAcentos(item.textContent).indexOf(needle) === -1;
				});
			});
			finder.addEventListener("click", function (event) { event.stopPropagation(); });
			panel.appendChild(finder);
		}

		options.forEach(function (option) {
			var item = document.createElement("label");
			item.className = "wchDropItem";
			var box = document.createElement("input");
			box.type = "checkbox";
			box.checked = selected.indexOf(option.value) !== -1;
			box.addEventListener("change", function () {
				var at = state[key].indexOf(option.value);
				if (box.checked && at === -1) {
					state[key].push(option.value);
				} else if (!box.checked && at !== -1) {
					state[key].splice(at, 1);
				}
				if (key === "planteles") {
					// Courses and periods differ per campus, so the whole bar is rebuilt.
					limpiarSeleccionesFueraDeAlcance();
					render();
					return;
				}
				// Anything else: keep the panel open so several boxes can be ticked
				// in a row, and only repaint the table.
				refrescarBoton();
				renderSheet();
			});
			item.appendChild(box);
			item.appendChild(document.createTextNode(" " + option.label));
			panel.appendChild(item);
		});

		var clear = document.createElement("button");

		function refrescarBoton() {
			var count = state[key].length;
			button.className = "wchDropBtn" + (count > 0 ? " wchDropBtnOn" : "");
			button.textContent = count > 0 ? label + " (" + count + ")" : label;
			clear.hidden = count < 1;
		}

		clear.type = "button";
		clear.className = "wchDropClear";
		clear.textContent = "Quitar selección";
		clear.hidden = selected.length < 1;
		clear.addEventListener("click", function () {
			state[key] = [];
			panel.querySelectorAll("input[type=checkbox]").forEach(function (box) { box.checked = false; });
			if (key === "planteles") {
				render();
				return;
			}
			refrescarBoton();
			renderSheet();
		});
		panel.appendChild(clear);

		button.addEventListener("click", function (event) {
			event.stopPropagation();
			var wasOpen = !panel.hidden;
			cerrarDropdowns();
			panel.hidden = wasOpen;
		});
		panel.addEventListener("click", function (event) { event.stopPropagation(); });

		wrap.appendChild(panel);
		return wrap;
	}

	function cerrarDropdowns() {
		root.querySelectorAll(".wchDropPanel").forEach(function (panel) { panel.hidden = true; });
	}

	function limpiarSeleccionesFueraDeAlcance() {
		var alcance = porPlantel();
		var cursos = unique(alcance.map(function (h) { return h.curso; }));
		var periodos = unique(alcance.map(function (h) { return h.periodo; }));
		state.cursos = state.cursos.filter(function (c) { return cursos.indexOf(c) !== -1; });
		state.periodos = state.periodos.filter(function (p) { return periodos.indexOf(p) !== -1; });
	}

	// ---- rendering -------------------------------------------------------

	function renderCampusStep() {
		el.campusGrid.innerHTML = "";
		if (data.planteles.length < 1) {
			el.campusGrid.innerHTML = '<p class="wchEmpty">Tu rol no tiene planteles con horarios en el catálogo.</p>';
			return;
		}
		data.planteles.forEach(function (campus) {
			var count = data.horarios.filter(function (h) { return h.plantel === campus.id; }).length;
			var card = document.createElement("button");
			card.type = "button";
			card.className = "wchCampusCard";
			card.innerHTML = '<span class="wchCampusName"></span><span class="wchCampusCount"></span>';
			card.querySelector(".wchCampusName").textContent = campus.nombre;
			card.querySelector(".wchCampusCount").textContent = count + (count === 1 ? " horario" : " horarios");
			card.addEventListener("click", function () {
				state.planteles = [campus.id];
				state.cursos = [];
				state.periodos = [];
				state.dias = [];
				state.estados = [];
				state.q = "";
				el.search.value = "";
				render();
			});
			el.campusGrid.appendChild(card);
		});
	}

	function renderFilters() {
		var alcance = porPlantel();

		var cursos = unique(alcance.map(function (h) { return h.curso; }))
			.sort(function (a, b) { return a.localeCompare(b, "es"); })
			.map(function (c) { return { value: c, label: c }; });

		var periodos = unique(alcance.map(function (h) { return h.periodo; }))
			.sort(function (a, b) { return periodoOrden(b) - periodoOrden(a) || a.localeCompare(b, "es"); })
			.map(function (p) { return { value: p, label: p }; });

		var diasPresentes = [];
		alcance.forEach(function (h) {
			h.dias.forEach(function (d) {
				if (diasPresentes.indexOf(d) === -1) { diasPresentes.push(d); }
			});
		});
		diasPresentes.sort(function (a, b) { return a - b; });
		var dias = diasPresentes.map(function (d) { return { value: d, label: DIAS[d] }; });

		var planteles = data.planteles.map(function (c) { return { value: c.id, label: c.nombre }; });

		el.filters.innerHTML = "";
		el.filters.appendChild(dropdown("Plantel", "planteles", planteles));
		el.filters.appendChild(dropdown("Curso", "cursos", cursos));
		el.filters.appendChild(dropdown("Período", "periodos", periodos));
		el.filters.appendChild(dropdown("Día", "dias", dias));
		if (data.verStatus === true) {
			var statusPresentes = unique(porPlantel().map(function (h) { return h.status; }))
				.sort(function (a, b) { return a.localeCompare(b, "es"); })
				.map(function (v) { return { value: v, label: v }; });
			el.filters.appendChild(dropdown("Status", "status", statusPresentes));
		}
		el.filters.appendChild(dropdown("Estado", "estados", [
			{ value: "por-comenzar", label: "Por comenzar" },
			{ value: "en-curso", label: "En curso" }
		]));
	}

	/** Quien puede ver los otros status igual empieza viendo solo los activos. */
	function statusPorDefecto() {
		return data && data.verStatus === true ? ["Activo"] : [];
	}

	function nombrePlantel(id) {
		for (var i = 0; i < data.planteles.length; i++) {
			if (data.planteles[i].id === id) {
				return data.planteles[i].nombre;
			}
		}
		return "";
	}

	function nombresPlanteles() {
		return data.planteles
			.filter(function (c) { return state.planteles.indexOf(c.id) !== -1; })
			.map(function (c) { return c.nombre; });
	}

	function renderSheet() {
		var enFiltro = filtrados();
		var filas = enFiltro.filter(function (h) { return state.excluidos.indexOf(h.id) === -1; });
		var ocultos = enFiltro.length - filas.length;

		// La columna de status solo aparece cuando hay algo que no sea "Activo" en
		// pantalla: si no, sería una columna que siempre dice lo mismo.
		var statusVistos = unique(filas.map(function (h) { return h.status; }));
		var verStatus = data.verStatus === true
			&& (statusVistos.length > 1 || (statusVistos.length === 1 && statusVistos[0] !== "Activo"));

		el.restoreHidden.hidden = ocultos < 1;
		el.restoreHidden.textContent = ocultos === 1 ? "Regresar 1 quitado" : "Regresar " + ocultos + " quitados";

		el.sheetTitle.textContent = nombresPlanteles().join(" · ") || "Horarios";

		var trozos = [filas.length + (filas.length === 1 ? " horario" : " horarios")];
		if (state.cursos.length > 0) { trozos.push(state.cursos.join(", ")); }
		if (state.periodos.length > 0) { trozos.push(state.periodos.join(", ")); }
		if (state.dias.length > 0) {
			trozos.push(state.dias.slice().sort(function (a, b) { return a - b; })
				.map(function (d) { return DIAS[d]; }).join(", "));
		}
		if (state.estados.length === 1) {
			trozos.push(ESTADOS[state.estados[0]] || state.estados[0]);
		}
		if (verStatus) {
			trozos.push("Status: " + statusVistos.sort().join(", "));
		}
		// Cuántos se quitaron va solo en el botón de arriba, nunca dentro de la hoja:
		// la hoja es lo que ve el cliente en la captura.
		el.sheetSummary.textContent = trozos.join(" · ");

		copiables = filas;
		el.copyList.textContent = filas.length > 0 ? "Copiar (" + filas.length + ")" : "Copiar";
		el.copyList.disabled = filas.length < 1;
		ocultarAviso();

		if (filas.length < 1) {
			el.tableWrap.innerHTML = '<p class="wchEmpty">No hay horarios con esos filtros.</p>';
			return;
		}

		// The plantel column only earns its place when more than one is on screen.
		var variosPlanteles = state.planteles.length > 1;
		// El conteo es interno: nunca entra al texto que se copia para un cliente.
		var verAlumnos = data.verAlumnos === true;

		var table = document.createElement("table");
		table.className = "wchGrid";
		table.innerHTML =
			"<thead><tr>" +
			"<th>Curso</th>" + (variosPlanteles ? "<th>Plantel</th>" : "") +
			"<th>Periodo</th><th>Horario</th><th>Inicia</th><th>Profesor</th>" +
			(verStatus ? "<th>Status</th>" : "") +
			(verAlumnos ? "<th>Alumnos</th>" : "") +
			"<th class=\"wchCellDrop\"></th>" +
			"</tr></thead>";

		var body = document.createElement("tbody");
		filas.forEach(function (h) {
			var row = document.createElement("tr");

			var curso = document.createElement("td");
			curso.className = "wchCellCourse";
			var nombre = document.createElement("span");
			nombre.className = "wchCourseName";
			nombre.textContent = h.curso;
			curso.appendChild(nombre);
			row.appendChild(curso);

			if (variosPlanteles) {
				row.appendChild(celda(nombrePlantel(h.plantel), "Plantel", "wchCellCampus"));
			}
			row.appendChild(celda(h.periodo, "Periodo", "wchCellPeriod"));
			// Cada día en su propio renglón: un curso de dos días en una sola línea
			// hacía la columna tan ancha que la tabla no cabía en la pantalla.
			var horario = document.createElement("td");
			horario.className = "wchCellSchedule";
			horario.setAttribute("data-label", "Horario: ");
			(h.sesiones && h.sesiones.length > 0 ? h.sesiones : [h.horario]).forEach(function (sesion) {
				var linea = document.createElement("span");
				linea.className = "wchSesion";
				linea.textContent = sesion;
				horario.appendChild(linea);
			});
			row.appendChild(horario);

			var inicia = document.createElement("td");
			inicia.className = "wchCellDate";
			inicia.setAttribute("data-label", "Inicia: ");
			inicia.appendChild(document.createTextNode(h.inicioTexto));
			if (h.estado === "por-comenzar" && h.status === "Activo") {
				var badge = document.createElement("span");
				badge.className = "wchBadge";
				badge.textContent = "Por comenzar";
				inicia.appendChild(badge);
			}
			row.appendChild(inicia);

			row.appendChild(celda(h.maestro || "–", "Profesor", "wchCellTeacher"));

			if (verStatus) {
				row.appendChild(celda(h.status, "Status", "wchCellStatus"));
			}
			if (verAlumnos) {
				row.appendChild(celda(String(h.alumnos === undefined ? 0 : h.alumnos),
					"Alumnos", "wchCellSeats"));
			}

			// La × solo se ve al pasar el cursor, y desaparece en "Vista limpia",
			// para que no salga en la captura que va al cliente.
			var quitar = document.createElement("td");
			quitar.className = "wchCellDrop";
			var boton = document.createElement("button");
			boton.type = "button";
			boton.className = "wchDropRow";
			boton.textContent = "×";
			boton.title = "Quitar este horario de la lista";
			boton.setAttribute("aria-label", "Quitar este horario de la lista");
			boton.addEventListener("click", function () {
				if (state.excluidos.indexOf(h.id) === -1) {
					state.excluidos.push(h.id);
				}
				renderSheet();
			});
			quitar.appendChild(boton);
			row.appendChild(quitar);
			body.appendChild(row);
		});

		table.appendChild(body);

		// El total va al pie de la columna. Son PERSONAS DISTINTAS, no matrículas
		// (Esteban, 2026-09-17): quien lleva dos cursos cuenta una vez. Por eso no se
		// suma la columna, se juntan los números de pizarra y se cuentan los distintos.
		if (verAlumnos) {
			var vistos = {};
			var matriculas = 0;
			filas.forEach(function (h) {
				matriculas += h.alumnos === undefined ? 0 : h.alumnos;
				(h.quienes || []).forEach(function (quien) { vistos[quien] = true; });
			});
			var personas = Object.keys(vistos).length;
			if (personas < 1 && matriculas > 0) { personas = matriculas; }

			var cuantos = filas.length === 1 ? "1 horario" : filas.length + " horarios";
			var texto = personas === matriculas
				? "Total de alumnos en " + cuantos
				: "Alumnos distintos en " + cuantos + " (" + matriculas + " matrículas)";

			// Todo lo que va antes de la columna de Alumnos se junta en una celda: Curso, Periodo, Horario,
			// Inicia y Profesor (+ Plantel y Status si se ven). Era 6 y sobraba una columna fantasma.
			var previas = 5 + (variosPlanteles ? 1 : 0) + (verStatus ? 1 : 0);
			var pie = document.createElement("tfoot");
			var pieRow = document.createElement("tr");
			var etiqueta = document.createElement("td");
			etiqueta.className = "wchCellTotalLabel";
			etiqueta.colSpan = previas;
			etiqueta.textContent = texto;
			pieRow.appendChild(etiqueta);
			pieRow.appendChild(celda(String(personas), "", "wchCellSeats wchCellTotal"));
			var relleno = document.createElement("td");
			relleno.className = "wchCellDrop";
			pieRow.appendChild(relleno);
			pie.appendChild(pieRow);
			table.appendChild(pie);
		}

		el.tableWrap.innerHTML = "";
		el.tableWrap.appendChild(table);
	}

	/**
	 * El texto que se pega en Woztell o WhatsApp. Se agrupa por curso, y dentro por
	 * período (Esteban, 2026-09-14). Los asteriscos son la negrita de WhatsApp.
	 */
	function textoParaCopiar(filas) {
		var variosPlanteles = state.planteles.length > 1;

		var bloques = [];
		var indice = {};
		filas.forEach(function (h) {
			var clave = h.plantel + "|" + h.curso;
			if (!(clave in indice)) {
				indice[clave] = bloques.length;
				bloques.push({ plantel: h.plantel, curso: h.curso, periodos: [], porPeriodo: {} });
			}
			var bloque = bloques[indice[clave]];
			if (!(h.periodo in bloque.porPeriodo)) {
				bloque.porPeriodo[h.periodo] = [];
				bloque.periodos.push(h.periodo);
			}
			bloque.porPeriodo[h.periodo].push(h);
		});

		return bloques.map(function (bloque) {
			bloque.periodos.forEach(function (periodo) {
				bloque.porPeriodo[periodo].sort(porFechaYHora);
			});

			var total = 0;
			bloque.periodos.forEach(function (periodo) { total += bloque.porPeriodo[periodo].length; });

			var encabezado = [];
			if (variosPlanteles) {
				encabezado.push("*Plantel:* " + nombrePlantel(bloque.plantel));
			}
			encabezado.push("*Curso:* " + bloque.curso);

			// Un solo horario: cabe el detalle completo, con profesor.
			if (total === 1) {
				var solo = bloque.porPeriodo[bloque.periodos[0]][0];
				encabezado.push("*Periodo:* " + bloque.periodos[0]);
				encabezado.push("*Horario:* " + solo.horario);
				encabezado.push("Inicia: " + solo.inicioTexto);
				if (!variosPlanteles && solo.maestro !== "") {
					encabezado.push("*Profesor:* " + solo.maestro);
				}
				return encabezado.join("\n");
			}

			if (bloque.periodos.length === 1) {
				encabezado.push("*Periodo:* " + bloque.periodos[0]);
				encabezado.push("*Horarios Disponibles:*");
				return encabezado.join("\n") + "\n"
					+ bloque.porPeriodo[bloque.periodos[0]].map(comoOpcion).join("\n\n");
			}

			var partes = bloque.periodos.map(function (periodo) {
				return "*Periodo:* " + periodo + "\n"
					+ bloque.porPeriodo[periodo].map(comoOpcion).join("\n\n");
			});
			return encabezado.join("\n") + "\n\n" + partes.join("\n\n");
		}).join("\n\n");
	}

	function comoOpcion(h) {
		return h.horario + "\nInicia: " + h.inicioTexto;
	}

	function porFechaYHora(a, b) {
		return (a.inicio < b.inicio ? -1 : (a.inicio > b.inicio ? 1 : 0))
			|| (a.minuto - b.minuto)
			|| ((a.dias[0] === undefined ? 99 : a.dias[0]) - (b.dias[0] === undefined ? 99 : b.dias[0]));
	}

	// data-label is what the phone layout shows in front of the value.
	function celda(text, label, className) {
		var cell = document.createElement("td");
		cell.textContent = text;
		if (label) {
			cell.setAttribute("data-label", label + ": ");
		}
		if (className) {
			cell.className = className;
		}
		return cell;
	}

	function render() {
		el.loading.hidden = true;
		var enLista = state.planteles.length > 0;
		el.campusStep.hidden = enLista;
		el.listStep.hidden = !enLista;
		if (!enLista) {
			renderCampusStep();
			return;
		}
		renderFilters();
		renderSheet();
		el.stamp.textContent = data.generado;
	}

	// ---- wiring ----------------------------------------------------------

	el.search.addEventListener("input", function () {
		state.q = el.search.value;
		renderSheet();
	});

	pieza("backToCampus").addEventListener("click", function () {
		state.planteles = [];
		render();
	});

	pieza("clearFilters").addEventListener("click", function () {
		state.cursos = [];
		state.periodos = [];
		state.dias = [];
		state.estados = [];
		state.status = statusPorDefecto();
		state.q = "";
		state.excluidos = [];
		el.search.value = "";
		render();
	});

	pieza("cleanView").addEventListener("click", function () {
		root.classList.toggle("wchLimpia");
		this.textContent = root.classList.contains("wchLimpia") ? "Mostrar filtros" : "Vista limpia";
	});

	el.copyList.addEventListener("click", function () {
		// Nada se recorta a escondidas: si son demasiados, se explica qué hacer.
		if (copiables.length > MAX_COPIAR) {
			mostrarAviso("No se pueden copiar tantos horarios a la vez, utilice el filtro para "
				+ "mostrar solo los horarios que desea compartir, hasta un máximo de "
				+ MAX_COPIAR + " a la vez.", "mal");
			return;
		}
		copiarAlPortapapeles(textoParaCopiar(copiables)).then(function (bien) {
			if (!bien) {
				mostrarAviso("No se pudo copiar. Inténtalo de nuevo.", "mal");
				return;
			}
			registrarCopia();
			mostrarAviso("Copiado: " + copiables.length
				+ (copiables.length === 1 ? " horario listo" : " horarios listos")
				+ " para pegar.", "bien");
		});
	});

	/** Deja constancia de la copia, sin esperar respuesta y sin molestar a nadie si falla. */
	function registrarCopia() {
		try {
			opciones.registrarCopia({
				total: copiables.length,
				ids: copiables.map(function (h) { return h.id; }),
				planteles: nombresPlanteles(),
				cursos: state.cursos,
				periodos: state.periodos,
				busqueda: state.q
			});
		} catch (e) { /* el registro nunca estorba al usuario */ }
	}

	var temporizador = null;

	function mostrarAviso(mensaje, tono) {
		el.copyNote.textContent = mensaje;
		el.copyNote.className = "wchCopyNote wchCopyNote" + (tono === "bien" ? "Ok" : "Mal");
		el.copyNote.hidden = false;
		if (tono === "bien") {
			temporizador = window.setTimeout(ocultarAviso, 4000);
		}
	}

	function ocultarAviso() {
		el.copyNote.hidden = true;
	}

	/** Clipboard API where it exists; the old textarea trick where it does not. */
	function copiarAlPortapapeles(texto) {
		if (navigator.clipboard && window.isSecureContext) {
			return navigator.clipboard.writeText(texto)
				.then(function () { return true; })
				.catch(function () { return conTextarea(texto); });
		}
		return Promise.resolve(conTextarea(texto));
	}

	function conTextarea(texto) {
		var area = document.createElement("textarea");
		area.value = texto;
		area.setAttribute("readonly", "readonly");
		area.style.position = "fixed";
		area.style.opacity = "0";
		document.body.appendChild(area);
		area.select();
		var bien = false;
		try {
			bien = document.execCommand("copy");
		} catch (e) {
			bien = false;
		}
		document.body.removeChild(area);
		return bien;
	}

	el.restoreHidden.addEventListener("click", function () {
		state.excluidos = [];
		renderSheet();
	});

	document.addEventListener("click", cerrarDropdowns);

	opciones.cargar()
		.then(function (payload) {
			if (!vivo) { return; }
			data = payload;
			state.status = statusPorDefecto();
			// Abre directo en el plantel que se tiene elegido en WAPP, si está en el catálogo.
			var inicial = Number(opciones.plantelInicial);
			state.planteles = data.planteles.some(function (c) { return c.id === inicial; }) ? [inicial] : [];
			render();
		})
		.catch(function () {
			if (vivo) {
				el.loading.textContent = "No se pudieron cargar los horarios. Recarga la página.";
			}
		});

	return function desmontar() {
		vivo = false;
		document.removeEventListener("click", cerrarDropdowns);
		if (temporizador) { window.clearTimeout(temporizador); }
		root.innerHTML = "";
		root.classList.remove("wchLimpia");
	};
}
